// extracted by mini-css-extract-plugin
export var formContainer = "_ld-0";
export var message = "_ld-1";